import React from "react";

import MobileGuideRunner from "../base/MobileGuideRunner";

import { gettingStartedForMobileConfiguration } from "./configuration";

const GettingStartedForMobile = () => {
  return <MobileGuideRunner descriptor={gettingStartedForMobileConfiguration} />;
};

export default GettingStartedForMobile;
